<script>
  export let options = [];
  export let selected = "";
  export let selectedRgb = "";

  let show = false;
</script>

<div class="component">
  <div
    class="item"
    on:click={() => {
      show = !show;
    }}
  >
    <span
      class="color"
      style="background-color: rgb{selectedRgb !== ''
        ? selectedRgb
        : options[0].rgb};"
    >
      &nbsp;
    </span>
    {selected || options[0].name}
  </div>

  {#if show}
    <div class="options">
      {#each options as item, idx}
        <div
          class="option"
          on:click={() => {
            selected = item.name;
            selectedRgb = options[idx].rgb;
            show = false;
          }}
        >
          <span class="color" style="background-color: rgb{options[idx].rgb};">
            &nbsp;
          </span>

          {item.name}
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .component {
    position: relative;
  }

  .color {
    width: 2rem;
    height: 2rem;
    border-radius: 0.5rem;
    padding-right: 0.5rem;
    display: inline-block;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .item {
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    padding: 1.2rem 1rem;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    cursor: pointer;
    user-select: none;
    text-transform: capitalize;
  }

  .options {
    position: absolute;
    top: 100%;
    margin-top: 1rem;
    right: 0;
    padding: 1.5rem;
    width: 100%;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
    border-radius: 0.5rem;
    z-index: 10;
    /* height: 100%; */
    max-height: 30rem;
    overflow-y: auto;
    background-color: #fff;
  }

  .option {
    margin-top: 0.5rem;
    color: #666;
    cursor: pointer;
    text-transform: capitalize;
  }
</style>
